export const LAYOUT_BLOCK_PADDINGS = {
  SIZE_20: '--layout-block-paddings-size-20',
  SIZE_30: '--layout-block-paddings-size-30',
  SIZE_40: '--layout-block-paddings-size-40',
  SIZE_50: '--layout-block-paddings-size-50',
} as const
export type LAYOUT_BLOCK_PADDINGS =
  (typeof LAYOUT_BLOCK_PADDINGS)[keyof typeof LAYOUT_BLOCK_PADDINGS]

export const MC_PADDINGS = {
  MC_TVSHOW_DETAILS_PAGE_EPISODES: '--mc-paddings-episodes-tvshow-details',
} as const
export type MC_PADDINGS = (typeof MC_PADDINGS)[keyof typeof MC_PADDINGS]
